import React, { useState } from 'react';
import RoleBasedHeader from '../../components/ui/RoleBasedHeader';
import BreadcrumbNavigation from '../../components/ui/BreadcrumbNavigation';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';

const FactoryTransporterManagement = () => {
  const [activeTab, setActiveTab] = useState('list');
  const [registrationStep, setRegistrationStep] = useState(1);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedTransporter, setSelectedTransporter] = useState(null);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [deleteType, setDeleteType] = useState(null);
  const [transporterData, setTransporterData] = useState({
    // Company Details
    companyName: '',
    registrationNumber: '',
    gstNumber: '',
    panNumber: '',
    transportLicense: '',
    establishedYear: '',
    
    // Contact Information
    ownerName: '',
    primaryContact: '',
    secondaryContact: '',
    email: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
    
    // Business Details
    fleetSize: '',
    operatingStates: [],
    servicesOffered: [],
    
    // Documents
    gstCertificate: null,
    insuranceCertificate: null,
    panCard: null
  });

  const [vehicleData, setVehicleData] = useState({
    transporterId: '',
    vehicleNumber: '',
    vehicleType: '',
    capacity: '',
    driverName: '',
    driverContact: '',
    driverLicense: '',
    insuranceNumber: '',
    insuranceExpiry: '',
    rcCopy: null,
    insuranceCopy: null,
    fitnessDocument: null,
    frontPhoto: null,
    sidePhoto: null,
    backPhoto: null
  });

  const [transporters, setTransporters] = useState([
    {
      id: 1,
      companyName: 'Swift Logistics Pvt Ltd',
      registrationNumber: 'TRN-MH-2020-001',
      gstNumber: '27AABCS1234A1Z5',
      primaryContact: '+91 98765 43210',
      email: 'contact@swiftlogistics.com',
      fleetSize: 25,
      operatingStates: ['Maharashtra', 'Gujarat', 'Karnataka'],
      status: 'verified',
      verificationDate: '2025-10-15',
      vehicles: [
        {
          id: 'V001',
          vehicleNumber: 'MH 12 AB 1234',
          vehicleType: '20-Ton Truck',
          capacity: 20,
          driverName: 'Rajesh Kumar',
          driverContact: '+91 98765 11111',
          insuranceExpiry: '2026-03-15',
          status: 'active'
        },
        {
          id: 'V002',
          vehicleNumber: 'MH 12 CD 5678',
          vehicleType: '25-Ton Truck',
          capacity: 25,
          driverName: 'Suresh Patil',
          driverContact: '+91 98765 22222',
          insuranceExpiry: '2026-05-20',
          status: 'active'
        }
      ]
    },
    {
      id: 2,
      companyName: 'Express Transport Services',
      registrationNumber: 'TRN-GJ-2021-005',
      gstNumber: '24AABCS5678B1Z9',
      primaryContact: '+91 98765 99999',
      email: 'info@expresstransport.com',
      fleetSize: 15,
      operatingStates: ['Gujarat', 'Rajasthan'],
      status: 'pending',
      verificationDate: null,
      vehicles: [
        {
          id: 'V003',
          vehicleNumber: 'GJ 01 EF 9012',
          vehicleType: '18-Ton Truck',
          capacity: 18,
          driverName: 'Amit Shah',
          driverContact: '+91 98765 33333',
          insuranceExpiry: '2025-12-30',
          status: 'active'
        }
      ]
    }
  ]);

  const stateOptions = ['Maharashtra', 'Gujarat', 'Karnataka', 'Uttar Pradesh', 'Tamil Nadu', 'Rajasthan', 'Punjab', 'Haryana'];
  const vehicleTypes = ['Truck', 'Trailer', 'Container 20ft', 'Container 40ft', 'Tanker'];
  const serviceOptions = ['Full Truck Load (FTL)', 'Part Load', 'Multi-drop', 'Express Delivery', 'Temperature Controlled'];

  const totalSteps = 3;

  const handleTransporterInputChange = (field, value) => {
    setTransporterData({ ...transporterData, [field]: value });
  };

  const handleVehicleInputChange = (field, value) => {
    setVehicleData({ ...vehicleData, [field]: value });
  };

  const handleStateToggle = (state) => {
    const currentStates = transporterData?.operatingStates;
    if (currentStates?.includes(state)) {
      setTransporterData({ 
        ...transporterData, 
        operatingStates: currentStates?.filter(s => s !== state) 
      });
    } else {
      setTransporterData({ 
        ...transporterData, 
        operatingStates: [...currentStates, state] 
      });
    }
  };

  const handleServiceToggle = (service) => {
    const currentServices = transporterData?.servicesOffered;
    if (currentServices?.includes(service)) {
      setTransporterData({ 
        ...transporterData, 
        servicesOffered: currentServices?.filter(s => s !== service) 
      });
    } else {
      setTransporterData({ 
        ...transporterData, 
        servicesOffered: [...currentServices, service] 
      });
    }
  };

  const handleTransporterFileUpload = (field, file) => {
    setTransporterData({ ...transporterData, [field]: file });
  };

  const handleVehicleFileUpload = (field, file) => {
    setVehicleData({ ...vehicleData, [field]: file });
  };

  const handleNext = () => {
    if (registrationStep < totalSteps) {
      setRegistrationStep(registrationStep + 1);
    }
  };

  const handlePrevious = () => {
    if (registrationStep > 1) {
      setRegistrationStep(registrationStep - 1);
    }
  };

  const handleTransporterSubmit = () => {
    if (!transporterData?.companyName || !transporterData?.gstNumber || !transporterData?.primaryContact) {
      alert('Please fill all required fields');
      return;
    }

    const newTransporter = {
      id: transporters?.length + 1,
      companyName: transporterData?.companyName,
      registrationNumber: transporterData?.registrationNumber,
      gstNumber: transporterData?.gstNumber,
      primaryContact: transporterData?.primaryContact,
      email: transporterData?.email,
      fleetSize: parseInt(transporterData?.fleetSize) || 0,
      operatingStates: transporterData?.operatingStates,
      status: 'pending',
      verificationDate: null,
      vehicles: []
    };

    setTransporters([...transporters, newTransporter]);
    alert('Transporter registration submitted successfully! Verification pending.');
    
    setRegistrationStep(1);
    setTransporterData({
      companyName: '',
      registrationNumber: '',
      gstNumber: '',
      panNumber: '',
      transportLicense: '',
      establishedYear: '',
      ownerName: '',
      primaryContact: '',
      secondaryContact: '',
      email: '',
      address: '',
      city: '',
      state: '',
      pincode: '',
      fleetSize: '',
      operatingStates: [],
      servicesOffered: [],
      gstCertificate: null,
      insuranceCertificate: null,
      panCard: null
    });
    setActiveTab('list');
  };

  const handleVehicleSubmit = () => {
    if (!vehicleData?.transporterId || !vehicleData?.vehicleNumber || !vehicleData?.vehicleType) {
      alert('Please fill all required fields');
      return;
    }

    const transporterIndex = transporters?.findIndex(t => t?.id === parseInt(vehicleData?.transporterId));
    if (transporterIndex === -1) {
      alert('Invalid transporter selected');
      return;
    }

    const newVehicle = {
      id: `V${Date.now()}`,
      vehicleNumber: vehicleData?.vehicleNumber,
      vehicleType: vehicleData?.vehicleType,
      capacity: parseInt(vehicleData?.capacity) || 0,
      driverName: vehicleData?.driverName,
      driverContact: vehicleData?.driverContact,
      insuranceExpiry: vehicleData?.insuranceExpiry,
      status: 'active'
    };

    const updatedTransporters = [...transporters];
    updatedTransporters[transporterIndex].vehicles = [
      ...updatedTransporters?.[transporterIndex]?.vehicles,
      newVehicle
    ];
    updatedTransporters[transporterIndex].fleetSize = updatedTransporters?.[transporterIndex]?.vehicles?.length;

    setTransporters(updatedTransporters);
    alert('Vehicle added successfully!');
    
    setVehicleData({
      transporterId: '',
      vehicleNumber: '',
      vehicleType: '',
      capacity: '',
      driverName: '',
      driverContact: '',
      driverLicense: '',
      insuranceNumber: '',
      insuranceExpiry: '',
      rcCopy: null,
      insuranceCopy: null,
      fitnessDocument: null,
      frontPhoto: null,
      sidePhoto: null,
      backPhoto: null
    });
    setActiveTab('list');
  };

  const handleEditDetails = (transporter) => {
    setTransporterData({
      companyName: transporter?.companyName,
      registrationNumber: transporter?.registrationNumber,
      gstNumber: transporter?.gstNumber,
      panNumber: '',
      transportLicense: '',
      establishedYear: '',
      ownerName: '',
      primaryContact: transporter?.primaryContact,
      secondaryContact: '',
      email: transporter?.email,
      address: '',
      city: '',
      state: '',
      pincode: '',
      fleetSize: transporter?.fleetSize?.toString(),
      operatingStates: transporter?.operatingStates || [],
      servicesOffered: [],
      gstCertificate: null,
      insuranceCertificate: null,
      panCard: null
    });
    setActiveTab('addTransporter');
  };

  const handleViewFullProfile = (transporter) => {
    setSelectedTransporter(transporter);
    setShowViewModal(true);
  };

  const handleDeleteTransporter = (transporter) => {
    setSelectedTransporter(transporter);
    setDeleteType('transporter');
    setShowDeleteModal(true);
  };

  const handleDeleteVehicle = (transporter, vehicle) => {
    setSelectedTransporter(transporter);
    setSelectedVehicle(vehicle);
    setDeleteType('vehicle');
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    if (deleteType === 'transporter') {
      const updatedTransporters = transporters?.filter(t => t?.id !== selectedTransporter?.id);
      setTransporters(updatedTransporters);
      alert(`Transporter "${selectedTransporter?.companyName}" deleted successfully!`);
    } else if (deleteType === 'vehicle') {
      const updatedTransporters = [...transporters];
      const transporterIndex = updatedTransporters?.findIndex(t => t?.id === selectedTransporter?.id);
      if (transporterIndex !== -1) {
        updatedTransporters[transporterIndex].vehicles = updatedTransporters?.[transporterIndex]?.vehicles?.filter(
          v => v?.id !== selectedVehicle?.id
        );
        updatedTransporters[transporterIndex].fleetSize = updatedTransporters?.[transporterIndex]?.vehicles?.length;
        setTransporters(updatedTransporters);
        alert(`Vehicle "${selectedVehicle?.vehicleNumber}" deleted successfully!`);
      }
    }
    setShowDeleteModal(false);
    setSelectedTransporter(null);
    setSelectedVehicle(null);
    setDeleteType(null);
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      verified: { label: 'Verified', color: 'bg-green-100 text-green-800', icon: 'CheckCircle' },
      pending: { label: 'Pending Verification', color: 'bg-yellow-100 text-yellow-800', icon: 'Clock' },
      rejected: { label: 'Rejected', color: 'bg-red-100 text-red-800', icon: 'XCircle' },
      active: { label: 'Active', color: 'bg-green-100 text-green-800', icon: 'CheckCircle' },
      inactive: { label: 'Inactive', color: 'bg-gray-100 text-gray-800', icon: 'XCircle' }
    };
    const config = statusConfig?.[status] || statusConfig?.pending;
    return (
      <span className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold ${config?.color}`}>
        <Icon name={config?.icon} size={14} />
        {config?.label}
      </span>
    );
  };

  const renderStepIndicator = () => (
    <div className="mb-8">
      <div className="flex items-center justify-between">
        {[1, 2, 3]?.map((step) => (
          <React.Fragment key={step}>
            <div className="flex flex-col items-center">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold ${
                registrationStep >= step
                  ? 'bg-gradient-to-r from-[#1e4a72] to-[#ff8c00] text-white'
                  : 'bg-muted text-muted-foreground'
              }`}>
                {step}
              </div>
              <span className="text-xs mt-2 text-center text-muted-foreground">
                {step === 1 && 'Company Info'}
                {step === 2 && 'Business Details'}
                {step === 3 && 'Documents'}
              </span>
            </div>
            {step < 3 && (
              <div className={`flex-1 h-1 mx-2 ${
                registrationStep > step ? 'bg-gradient-to-r from-[#1e4a72] to-[#ff8c00]' : 'bg-muted'
              }`} />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );

  const renderCompanyInformation = () => (
    <div className="space-y-4">
      <h3 className="text-xl font-bold text-foreground mb-4">Company Information</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Company Name *</label>
          <input
            type="text"
            value={transporterData?.companyName}
            onChange={(e) => handleTransporterInputChange('companyName', e?.target?.value)}
            className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
            placeholder="Enter company name"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Registration Number *</label>
          <input
            type="text"
            value={transporterData?.registrationNumber}
            onChange={(e) => handleTransporterInputChange('registrationNumber', e?.target?.value)}
            className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
            placeholder="TRN-XX-YYYY-NNN"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">GST Number *</label>
          <input
            type="text"
            value={transporterData?.gstNumber}
            onChange={(e) => handleTransporterInputChange('gstNumber', e?.target?.value)}
            className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
            placeholder="22AAAAA0000A1Z5"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">PAN Number</label>
          <input
            type="text"
            value={transporterData?.panNumber}
            onChange={(e) => handleTransporterInputChange('panNumber', e?.target?.value)}
            className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
            placeholder="ABCDE1234F"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Transport License *</label>
          <input
            type="text"
            value={transporterData?.transportLicense}
            onChange={(e) => handleTransporterInputChange('transportLicense', e?.target?.value)}
            className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
            placeholder="License number"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Established Year</label>
          <input
            type="number"
            value={transporterData?.establishedYear}
            onChange={(e) => handleTransporterInputChange('establishedYear', e?.target?.value)}
            className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
            placeholder="YYYY"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Owner Name *</label>
          <input
            type="text"
            value={transporterData?.ownerName}
            onChange={(e) => handleTransporterInputChange('ownerName', e?.target?.value)}
            className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
            placeholder="Enter owner name"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Primary Contact *</label>
          <input
            type="tel"
            value={transporterData?.primaryContact}
            onChange={(e) => handleTransporterInputChange('primaryContact', e?.target?.value)}
            className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
            placeholder="+91 XXXXX XXXXX"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Secondary Contact</label>
          <input
            type="tel"
            value={transporterData?.secondaryContact}
            onChange={(e) => handleTransporterInputChange('secondaryContact', e?.target?.value)}
            className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
            placeholder="+91 XXXXX XXXXX"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Email *</label>
          <input
            type="email"
            value={transporterData?.email}
            onChange={(e) => handleTransporterInputChange('email', e?.target?.value)}
            className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
            placeholder="contact@transporter.com"
          />
        </div>
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-foreground mb-2">Complete Address *</label>
          <textarea
            value={transporterData?.address}
            onChange={(e) => handleTransporterInputChange('address', e?.target?.value)}
            className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
            placeholder="Enter complete address"
            rows="3"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">City *</label>
          <input
            type="text"
            value={transporterData?.city}
            onChange={(e) => handleTransporterInputChange('city', e?.target?.value)}
            className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
            placeholder="City"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">State *</label>
          <input
            type="text"
            value={transporterData?.state}
            onChange={(e) => handleTransporterInputChange('state', e?.target?.value)}
            className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
            placeholder="State"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Pincode *</label>
          <input
            type="text"
            value={transporterData?.pincode}
            onChange={(e) => handleTransporterInputChange('pincode', e?.target?.value)}
            className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
            placeholder="000000"
          />
        </div>
      </div>
    </div>
  );

  const renderBusinessDetails = () => (
    <div className="space-y-4">
      <h3 className="text-xl font-bold text-foreground mb-4">Business Details</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Fleet Size *</label>
          <input
            type="number"
            value={transporterData?.fleetSize}
            onChange={(e) => handleTransporterInputChange('fleetSize', e?.target?.value)}
            className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
            placeholder="Number of vehicles"
          />
        </div>
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-foreground mb-2">Operating States *</label>
          <div className="flex flex-wrap gap-2">
            {stateOptions?.map(state => (
              <label key={state} className="flex items-center gap-2 cursor-pointer px-3 py-2 border border-border rounded-lg hover:bg-muted">
                <input
                  type="checkbox"
                  checked={transporterData?.operatingStates?.includes(state)}
                  onChange={() => handleStateToggle(state)}
                  className="w-4 h-4"
                />
                <span className="text-sm text-foreground">{state}</span>
              </label>
            ))}
          </div>
        </div>
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-foreground mb-2">Services Offered *</label>
          <div className="flex flex-wrap gap-2">
            {serviceOptions?.map(service => (
              <label key={service} className="flex items-center gap-2 cursor-pointer px-3 py-2 border border-border rounded-lg hover:bg-muted">
                <input
                  type="checkbox"
                  checked={transporterData?.servicesOffered?.includes(service)}
                  onChange={() => handleServiceToggle(service)}
                  className="w-4 h-4"
                />
                <span className="text-sm text-foreground">{service}</span>
              </label>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  const renderDocumentManagement = () => (
    <div className="space-y-4">
      <h3 className="text-xl font-bold text-foreground mb-4">Document Management</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">GST Certificate Upload *</label>
          <input
            type="file"
            onChange={(e) => handleTransporterFileUpload('gstCertificate', e?.target?.files?.[0])}
            className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
            accept=".pdf,.jpg,.jpeg,.png"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Transport License Upload *</label>
          <input
            type="file"
            onChange={(e) => handleTransporterFileUpload('transportLicense', e?.target?.files?.[0])}
            className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
            accept=".pdf,.jpg,.jpeg,.png"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Insurance Certificate Upload</label>
          <input
            type="file"
            onChange={(e) => handleTransporterFileUpload('insuranceCertificate', e?.target?.files?.[0])}
            className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
            accept=".pdf,.jpg,.jpeg,.png"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">PAN Card Upload</label>
          <input
            type="file"
            onChange={(e) => handleTransporterFileUpload('panCard', e?.target?.files?.[0])}
            className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
            accept=".pdf,.jpg,.jpeg,.png"
          />
        </div>
      </div>
    </div>
  );

  const renderTransporterRegistration = () => (
    <div className="bg-card border border-border rounded-lg p-6 shadow-lg">
      {renderStepIndicator()}
      
      <div className="mb-6">
        {registrationStep === 1 && renderCompanyInformation()}
        {registrationStep === 2 && renderBusinessDetails()}
        {registrationStep === 3 && renderDocumentManagement()}
      </div>

      <div className="flex justify-between gap-3">
        <Button
          onClick={handlePrevious}
          disabled={registrationStep === 1}
          variant="outline"
        >
          <Icon name="ChevronLeft" size={20} className="mr-2" />
          Previous
        </Button>
        
        {registrationStep < totalSteps ? (
          <Button
            onClick={handleNext}
            className="bg-gradient-to-r from-[#1e4a72] to-[#ff8c00] text-white"
          >
            Next
            <Icon name="ChevronRight" size={20} className="ml-2" />
          </Button>
        ) : (
          <Button
            onClick={handleTransporterSubmit}
            className="bg-gradient-to-r from-green-500 to-green-600 text-white"
          >
            <Icon name="CheckCircle" size={20} className="mr-2" />
            Submit Registration
          </Button>
        )}
      </div>
    </div>
  );

  const renderVehicleRegistration = () => (
    <div className="bg-card border border-border rounded-lg p-6 shadow-lg">
      <h3 className="text-xl font-bold text-foreground mb-6">Add New Vehicle</h3>
      
      <div className="space-y-4 mb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Select Transporter *</label>
            <select
              value={vehicleData?.transporterId}
              onChange={(e) => handleVehicleInputChange('transporterId', e?.target?.value)}
              className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
            >
              <option value="">Select transporter</option>
              {transporters?.map(transporter => (
                <option key={transporter?.id} value={transporter?.id}>
                  {transporter?.companyName} ({transporter?.registrationNumber})
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Vehicle Number *</label>
            <input
              type="text"
              value={vehicleData?.vehicleNumber}
              onChange={(e) => handleVehicleInputChange('vehicleNumber', e?.target?.value)}
              className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
              placeholder="XX 00 XX 0000"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Vehicle Type *</label>
            <select
              value={vehicleData?.vehicleType}
              onChange={(e) => handleVehicleInputChange('vehicleType', e?.target?.value)}
              className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
            >
              <option value="">Select type</option>
              {vehicleTypes?.map(type => (
                <option key={type} value={type}>{type}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Capacity (tons) *</label>
            <input
              type="number"
              value={vehicleData?.capacity}
              onChange={(e) => handleVehicleInputChange('capacity', e?.target?.value)}
              className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
              placeholder="Vehicle capacity"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Driver Name *</label>
            <input
              type="text"
              value={vehicleData?.driverName}
              onChange={(e) => handleVehicleInputChange('driverName', e?.target?.value)}
              className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
              placeholder="Driver full name"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Driver Contact *</label>
            <input
              type="tel"
              value={vehicleData?.driverContact}
              onChange={(e) => handleVehicleInputChange('driverContact', e?.target?.value)}
              className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
              placeholder="+91 XXXXX XXXXX"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Driver License Number</label>
            <input
              type="text"
              value={vehicleData?.driverLicense}
              onChange={(e) => handleVehicleInputChange('driverLicense', e?.target?.value)}
              className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
              placeholder="DL number"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Insurance Number</label>
            <input
              type="text"
              value={vehicleData?.insuranceNumber}
              onChange={(e) => handleVehicleInputChange('insuranceNumber', e?.target?.value)}
              className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
              placeholder="Insurance policy number"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Insurance Expiry Date *</label>
            <input
              type="date"
              value={vehicleData?.insuranceExpiry}
              onChange={(e) => handleVehicleInputChange('insuranceExpiry', e?.target?.value)}
              className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">RC Copy Upload</label>
            <input
              type="file"
              onChange={(e) => handleVehicleFileUpload('rcCopy', e?.target?.files?.[0])}
              className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
              accept=".pdf,.jpg,.jpeg,.png"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Insurance Copy Upload</label>
            <input
              type="file"
              onChange={(e) => handleVehicleFileUpload('insuranceCopy', e?.target?.files?.[0])}
              className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
              accept=".pdf,.jpg,.jpeg,.png"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Fitness Certificate Upload</label>
            <input
              type="file"
              onChange={(e) => handleVehicleFileUpload('fitnessDocument', e?.target?.files?.[0])}
              className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
              accept=".pdf,.jpg,.jpeg,.png"
            />
          </div>
        </div>

        {/* Vehicle Photos Section */}
        <div className="border-t border-border pt-6 mt-6">
          <h4 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
            <Icon name="Camera" size={20} className="text-[#ff8c00]" />
            Vehicle Photos (Optional)
          </h4>
          <p className="text-sm text-muted-foreground mb-4">
            Upload photos of the vehicle from different angles for verification (Optional)
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="space-y-2">
              <label className="block text-sm font-medium text-foreground mb-2">
                Front View Photo
              </label>
              <div className="border-2 border-dashed border-border rounded-lg p-4 hover:border-[#ff8c00] transition-colors">
                <input
                  type="file"
                  onChange={(e) => handleVehicleFileUpload('frontPhoto', e?.target?.files?.[0])}
                  className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
                  accept="image/*"
                />
                {vehicleData?.frontPhoto && (
                  <div className="mt-2 flex items-center gap-2 text-green-600 text-sm">
                    <Icon name="CheckCircle" size={16} />
                    <span>{vehicleData?.frontPhoto?.name}</span>
                  </div>
                )}
              </div>
              <p className="text-xs text-muted-foreground">Capture the front of the vehicle showing the number plate</p>
            </div>

            <div className="space-y-2">
              <label className="block text-sm font-medium text-foreground mb-2">
                Side View Photo
              </label>
              <div className="border-2 border-dashed border-border rounded-lg p-4 hover:border-[#ff8c00] transition-colors">
                <input
                  type="file"
                  onChange={(e) => handleVehicleFileUpload('sidePhoto', e?.target?.files?.[0])}
                  className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
                  accept="image/*"
                />
                {vehicleData?.sidePhoto && (
                  <div className="mt-2 flex items-center gap-2 text-green-600 text-sm">
                    <Icon name="CheckCircle" size={16} />
                    <span>{vehicleData?.sidePhoto?.name}</span>
                  </div>
                )}
              </div>
              <p className="text-xs text-muted-foreground">Capture the side profile showing the vehicle length</p>
            </div>

            <div className="space-y-2">
              <label className="block text-sm font-medium text-foreground mb-2">
                Back View Photo
              </label>
              <div className="border-2 border-dashed border-border rounded-lg p-4 hover:border-[#ff8c00] transition-colors">
                <input
                  type="file"
                  onChange={(e) => handleVehicleFileUpload('backPhoto', e?.target?.files?.[0])}
                  className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
                  accept="image/*"
                />
                {vehicleData?.backPhoto && (
                  <div className="mt-2 flex items-center gap-2 text-green-600 text-sm">
                    <Icon name="CheckCircle" size={16} />
                    <span>{vehicleData?.backPhoto?.name}</span>
                  </div>
                )}
              </div>
              <p className="text-xs text-muted-foreground">Capture the rear showing the back of the vehicle</p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-end gap-3">
        <Button
          onClick={() => setActiveTab('list')}
          variant="outline"
        >
          Cancel
        </Button>
        <Button
          onClick={handleVehicleSubmit}
          className="bg-gradient-to-r from-green-500 to-green-600 text-white"
        >
          <Icon name="CheckCircle" size={20} className="mr-2" />
          Add Vehicle
        </Button>
      </div>
    </div>
  );

  const renderTransportersList = () => (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold text-foreground">Registered Transporters</h2>
        <div className="flex gap-3">
          <Button
            onClick={() => setActiveTab('addTransporter')}
            className="bg-gradient-to-r from-[#1e4a72] to-[#ff8c00] text-white"
            iconName="Plus"
            iconPosition="left"
          >
            Add Transporter
          </Button>
          <Button
            onClick={() => setActiveTab('addVehicle')}
            className="bg-gradient-to-r from-green-500 to-green-600 text-white"
            iconName="Truck"
            iconPosition="left"
          >
            Add Vehicle
          </Button>
        </div>
      </div>
      
      <div className="space-y-6">
        {transporters?.map(transporter => (
          <div key={transporter?.id} className="bg-card border border-border rounded-lg p-6 shadow-md">
            <div className="flex justify-between items-start mb-4">
              <div>
                <h3 className="text-xl font-bold text-foreground">{transporter?.companyName}</h3>
                <p className="text-sm text-muted-foreground">{transporter?.registrationNumber}</p>
              </div>
              {getStatusBadge(transporter?.status)}
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
              <div className="flex items-center gap-2 text-sm">
                <Icon name="Phone" size={16} className="text-muted-foreground" />
                <span className="text-foreground">{transporter?.primaryContact}</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <Icon name="Mail" size={16} className="text-muted-foreground" />
                <span className="text-foreground">{transporter?.email}</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <Icon name="Truck" size={16} className="text-muted-foreground" />
                <span className="text-foreground">Fleet: {transporter?.fleetSize} vehicles</span>
              </div>
            </div>

            <div className="mb-4">
              <p className="text-sm font-medium text-foreground mb-2">Operating States:</p>
              <div className="flex flex-wrap gap-2">
                {transporter?.operatingStates?.map(state => (
                  <span key={state} className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs">
                    {state}
                  </span>
                ))}
              </div>
            </div>

            <div className="border-t border-border pt-4">
              <div className="flex justify-between items-center mb-3">
                <h4 className="text-lg font-semibold text-foreground">Vehicles ({transporter?.vehicles?.length})</h4>
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => {
                    setVehicleData({ ...vehicleData, transporterId: transporter?.id?.toString() });
                    setActiveTab('addVehicle');
                  }}
                  iconName="Plus"
                  iconPosition="left"
                >
                  Add Vehicle
                </Button>
              </div>
              
              {transporter?.vehicles?.length > 0 ? (
                <div className="space-y-3">
                  {transporter?.vehicles?.map(vehicle => (
                    <div key={vehicle?.id} className="bg-muted/50 rounded-lg p-4">
                      <div className="flex justify-between items-start mb-2">
                        <div>
                          <p className="font-semibold text-foreground">{vehicle?.vehicleNumber}</p>
                          <p className="text-sm text-muted-foreground">{vehicle?.vehicleType} - {vehicle?.capacity} tons</p>
                        </div>
                        <div className="flex gap-2">
                          {getStatusBadge(vehicle?.status)}
                          <button
                            onClick={() => handleDeleteVehicle(transporter, vehicle)}
                            className="p-1 text-red-600 hover:bg-red-50 rounded"
                            title="Delete Vehicle"
                          >
                            <Icon name="Trash2" size={16} />
                          </button>
                        </div>
                      </div>
                      <div className="mt-2 grid grid-cols-2 gap-2 text-sm">
                        <div>
                          <span className="text-muted-foreground">Driver:</span> {vehicle?.driverName}
                        </div>
                        <div>
                          <span className="text-muted-foreground">Contact:</span> {vehicle?.driverContact}
                        </div>
                        <div className="col-span-2">
                          <span className="text-muted-foreground">Insurance Expiry:</span> {vehicle?.insuranceExpiry}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-sm text-muted-foreground text-center py-4">No vehicles added yet</p>
              )}
            </div>

            <div className="flex gap-2 mt-4 border-t border-border pt-4">
              <Button 
                size="sm" 
                variant="outline" 
                className="flex-1"
                onClick={() => handleEditDetails(transporter)}
              >
                <Icon name="Edit" size={14} className="mr-2" />
                Edit Details
              </Button>
              <Button 
                size="sm" 
                variant="outline" 
                className="flex-1"
                onClick={() => handleViewFullProfile(transporter)}
              >
                <Icon name="Eye" size={14} className="mr-2" />
                View Full Profile
              </Button>
              <Button 
                size="sm" 
                variant="outline" 
                className="flex-1 text-red-600 border-red-300 hover:bg-red-50"
                onClick={() => handleDeleteTransporter(transporter)}
              >
                <Icon name="Trash2" size={14} className="mr-2" />
                Delete
              </Button>
            </div>
          </div>
        ))}
      </div>

      {/* View Profile Modal */}
      {showViewModal && selectedTransporter && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-card rounded-lg max-w-3xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-border flex justify-between items-center">
              <h3 className="text-xl font-bold text-foreground">Transporter Profile</h3>
              <button
                onClick={() => setShowViewModal(false)}
                className="p-2 hover:bg-muted rounded-lg"
              >
                <Icon name="X" size={20} />
              </button>
            </div>
            
            <div className="p-6 space-y-6">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-sm font-medium text-muted-foreground">Company Name</label>
                  <p className="text-foreground font-semibold">{selectedTransporter?.companyName}</p>
                </div>
                <div>
                  <label className="text-sm font-medium text-muted-foreground">Registration Number</label>
                  <p className="text-foreground font-semibold">{selectedTransporter?.registrationNumber}</p>
                </div>
                <div>
                  <label className="text-sm font-medium text-muted-foreground">GST Number</label>
                  <p className="text-foreground font-semibold">{selectedTransporter?.gstNumber}</p>
                </div>
                <div>
                  <label className="text-sm font-medium text-muted-foreground">Primary Contact</label>
                  <p className="text-foreground font-semibold">{selectedTransporter?.primaryContact}</p>
                </div>
                <div>
                  <label className="text-sm font-medium text-muted-foreground">Email</label>
                  <p className="text-foreground font-semibold">{selectedTransporter?.email}</p>
                </div>
                <div>
                  <label className="text-sm font-medium text-muted-foreground">Fleet Size</label>
                  <p className="text-foreground font-semibold">{selectedTransporter?.fleetSize} vehicles</p>
                </div>
                <div className="col-span-2">
                  <label className="text-sm font-medium text-muted-foreground">Operating States</label>
                  <div className="flex flex-wrap gap-2 mt-2">
                    {selectedTransporter?.operatingStates?.map(state => (
                      <span key={state} className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs">
                        {state}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="col-span-2">
                  <label className="text-sm font-medium text-muted-foreground">Status</label>
                  <div className="mt-2">{getStatusBadge(selectedTransporter?.status)}</div>
                </div>
                {selectedTransporter?.verificationDate && (
                  <div>
                    <label className="text-sm font-medium text-muted-foreground">Verification Date</label>
                    <p className="text-foreground font-semibold">{selectedTransporter?.verificationDate}</p>
                  </div>
                )}
              </div>
              
              <div className="border-t border-border pt-4">
                <h4 className="font-semibold text-foreground mb-4">Fleet Overview</h4>
                <div className="space-y-2">
                  {selectedTransporter?.vehicles?.map(vehicle => (
                    <div key={vehicle?.id} className="bg-muted/50 rounded p-3 flex justify-between items-center">
                      <div>
                        <p className="font-medium text-foreground">{vehicle?.vehicleNumber}</p>
                        <p className="text-sm text-muted-foreground">{vehicle?.vehicleType} - Driver: {vehicle?.driverName}</p>
                      </div>
                      {getStatusBadge(vehicle?.status)}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            
            <div className="p-6 border-t border-border">
              <Button
                onClick={() => setShowViewModal(false)}
                className="w-full"
                variant="outline"
              >
                Close
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-card rounded-lg max-w-md w-full">
            <div className="p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                  <Icon name="AlertTriangle" size={24} className="text-red-600" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-foreground">Confirm Delete</h3>
                  <p className="text-sm text-muted-foreground">This action cannot be undone</p>
                </div>
              </div>
              
              <p className="text-foreground mb-6">
                {deleteType === 'transporter' 
                  ? `Are you sure you want to delete transporter "${selectedTransporter?.companyName}"? This will also remove all associated vehicles.`
                  : `Are you sure you want to delete vehicle "${selectedVehicle?.vehicleNumber}"?`
                }
              </p>
              
              <div className="flex gap-3">
                <Button
                  onClick={() => setShowDeleteModal(false)}
                  variant="outline"
                  className="flex-1"
                >
                  Cancel
                </Button>
                <Button
                  onClick={confirmDelete}
                  className="flex-1 bg-red-600 text-white hover:bg-red-700"
                >
                  Delete
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );

  return (
    <div className="min-h-screen bg-background">
      <RoleBasedHeader />
      <BreadcrumbNavigation />
      
      <main className="main-content">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="mb-8">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-[#1e4a72] to-[#ff8c00] flex items-center justify-center">
                <Icon name="Users" size={24} color="#FFFFFF" />
              </div>
              <div>
                <h1 className="text-3xl font-bold text-foreground">Factory Transporter Management</h1>
                <p className="text-muted-foreground">Add, manage, and verify transporters and their vehicle fleets</p>
              </div>
            </div>
          </div>

          <div className="space-y-8">
            {activeTab === 'list' && renderTransportersList()}
            {activeTab === 'addTransporter' && renderTransporterRegistration()}
            {activeTab === 'addVehicle' && renderVehicleRegistration()}
          </div>
        </div>
      </main>
    </div>
  );
};

export default FactoryTransporterManagement;